module.exports = __webpack_public_path__ + "img/snExample.39357cbc.png";